<template>
    <div class="company-list">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="saleEntityList"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    align="center"
                ></el-table-column>
                <el-table-column
                    align="left"
                    label="Company"
                    prop="name"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column align="left" label="Type" prop="type">
                </el-table-column>
                <el-table-column align="left" label="Email" prop="email"  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Country"
                    prop="country_name"
                >
                </el-table-column>
                
                <el-table-column align="left" label="City" prop="city">
                </el-table-column>
                <el-table-column align="left" label="Rank" prop="rank">
                    <template slot-scope="scope">
                        <div>Lv.{{ scope.row.rank }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Balance" prop="balance">
                    <template slot-scope="scope">
                        <!-- <div>{{ scope.row.currency && scope.row.currency.symbol}}{{ scope.row.balance }}</div> -->
                        <div v-if="scope.row.currency">
                            {{ scope.row.currency.symbol
                            }}{{ scope.row.balance }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Business_code"
                    prop="business_code"
                >
                    <template slot-scope="scope">
                        <div>
                            {{
                                scope.row.business_code &&
                                scope.row.business_code.code
                            }}
                            <span v-if="scope.row.business_code"
                                >({{ scope.row.business_code.business }})</span
                            >
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Status">
                    <template slot-scope="scope">
                        <span
                            class="general-table-tag"
                            :class="[
                                scope.row.status == 'Actived'
                                    ? 'primary'
                                    : scope.row.status == 'Closed'
                                    ? 'info'
                                    : 'danger',
                            ]"
                        >
                            <i class="el-icon-s-help"></i>
                            {{ scope.row.status }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Created On"
                    prop="created_at"
                >
                </el-table-column>
                <el-table-column
                    label="Operation"
                    align="left"
                    width="150"
                    :fixed="operationFixed"
                >
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <edit
            :editVisible.sync="editVisible"
            :tableItem="tableItem"
            :funcName="funcName"
            :status="status"
        ></edit>
        <recharge
            :rechargeVisible.sync="rechargeVisible"
            :tableItem="tableItem"
            :funcName="funcName"
        ></recharge>
        <withdrawal
            :withdrawalVisible.sync="withdrawalVisible"
            :tableItem="tableItem"
            :funcName="funcName"
        ></withdrawal>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import { mapActions } from "vuex";
import edit from "./companyList/edit.vue";
import recharge from "./companyList/recharge.vue";
import withdrawal from "./companyList/withdrawal.vue";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Company、Email、BusinessCode",
            searchForm: {
                keyword: "",
                salesman: "",
                created_time: "",
                balance_range: ["", ""],
                level: "",
            },
            searchForm_transfer: {
                keyword: "",
                salesman: "",
                created_time: "",
                balance_range: ["", ""],
                level: "",
            },
            funcName: "saleEntityList",
            selectList: [],
            editVisible: false,
            rechargeVisible: false,
            withdrawalVisible: false,
            advanceSearchFields: {
                salesman: {
                    label: "Business Code",
                    type: "select",
                    options: [],
                },
                created_time: {
                    label: "Created On",
                    type: "cascader",
                },
                balance_range: {
                    label: "Balance Range",
                    type: "range",
                },
                level: {
                    label: "Level",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        ...mapActions(["getRntityRankSelect", "getBusinessCodeSelect"]),
        // 获取企业主体列表
        saleEntityList(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .saleEntityList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        // this.advanceSearchFields.status.options =
                        //     res.ext.tabs.map((item) => {
                        //         return { label: item.name, value: item.status };
                        //     });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "edit") {
                    this.editVisible = true;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                } else if (item.funcName == "recharge") {
                    this.rechargeVisible = true;
                } else if (item.funcName == "withdrawal") {
                    this.withdrawalVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.saleEntityList();
            this.getRntityRankSelect().then((res) => {
                this.advanceSearchFields.level.options = res.data.map(
                    (item) => {
                        return { label: item.rank_name, value: item.rank };
                    }
                );
            });
            this.getBusinessCodeSelect().then((res) => {
                this.advanceSearchFields.salesman.options = res.data.map(
                    (item) => {
                        return {
                            label: item.code + " (" + item.business + ")",
                            value: item.code,
                        };
                    }
                );
            });
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        edit,
        recharge,
        withdrawal,
    },
    computed: {
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
                {
                    label: this.$i18n.locale == "zh" ? "邀请码" : "Business Code",
                    key: "salesman",
                    type: "select",
                    props: {
                        list: this.advanceSearchFields.salesman.options,
                        nameKey: "label",
                        valueKey: "value",
                    },
                },
                {
                    label:
                        this.$i18n.locale == "zh" ? "创建时间" : "Created On",
                    key: "created_time",
                    type: "cascader",
                },
                {
                    label:
                        this.$i18n.locale == "zh" ? "余额范围" : "Balance Range",
                    key: "balance_range",
                    type: "range",
                },
                {
                    label: this.$i18n.locale == "zh" ? "等级" : "Level",
                    key: "level",
                    type: "select",
                    props: {
                        list: this.advanceSearchFields.level.options,
                        nameKey: "label",
                        valueKey: "value",
                    },
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    // v instanceof Array ? !!v.join('') newValue的值有数组时, 需要判断一下
                    if (v instanceof Array ? !!v.join('') : !!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.company-list {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
